<template>
  <div class="review-list" :class="{ 'm-20': !readOnly }">
    <base-section-title
      v-if="showSectionTitle"
      :title="readOnly ? '评审办法' : '设置评审办法'"
      class="m-b-24"
    >
      <template v-if="!inSupplier" v-slot:right-tool>
        <div class="flex">
          <el-button v-if="!readOnly" type="text" @click="importVisible = true">
            导入评审办法
          </el-button>
          <el-button type="text" @click="exportExcel">
            导出评审办法
          </el-button>
        </div>
      </template>
    </base-section-title>
    <div v-if="!readOnly">
      <h3>评审办法设置说明：</h3>
      <p class="tips">
        1.评审办法设置是用于激活在评审阶段的评审，不勾选则不进行未勾选的评审过程
      </p>
      <p class="tips ">
        2.你可以通过右上角导入的方式将评审办法内容导入到表单内，也可以通过一键导出将已添加的评审办法导出到excel表格中
      </p>
    </div>
    <el-form v-if="!readOnly" ref="formRef" :model="form" label-width="110px">
      <el-row :gutter="40">
        <el-col :sm="24" :xl="12">
          <el-form-item label="评审办法设置">
            <el-checkbox-group
              v-model="form.checkList"
              @change="changeReviewList"
            >
              <el-checkbox
                v-for="item in reviewWayOption"
                :key="item.value"
                :label="item.value"
                :disabled="
                  Number(item.value) ===
                    inquiryReviewTypeDict.QUALIFICATION.value ||
                    Number(item.value) === inquiryReviewTypeDict.QUOTATION.value
                "
              >
                {{ item.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="list.length > 0">
      <online-review-way
        v-for="(item, index) in list"
        :id="item.title"
        :ref="`way${item.wayType}`"
        :key="index"
        v-model="list[index]"
        :read-only="readOnly"
        :review-model="reviewModel"
      />
    </div>

    <template-import-dialog
      ref="templateImportDialog"
      v-model="importVisible"
      title="评审办法导入"
      tip-first="下载评审办法导入模板，根据所提供的模板编辑模板表格"
      tip-second="上传表格，点击确认完成评审办法导入"
      template-name="评审办法导入模版.xlsx"
      @upload="uploadTemplate"
      @remove="removeTemplate"
      @confirm="confirmImport"
    >
      <template v-slot:download>
        <download-file
          v-if="Number(reviewModel) === inquiryReviewModelDict.SYNTHESIS.value"
          :download-link="'/resources/线上评审办法导入模版.xlsx'"
        >
          <el-button class="m-l-5 download-btn" type="primary">
            下载
          </el-button>
        </download-file>
        <download-file
          v-if="
            Number(reviewModel) === inquiryReviewModelDict.LOWEST_MARK.value
          "
          :download-link="'/resources/线上评审办法导入模版最低价法.xlsx'"
        >
          <el-button class="m-l-5 download-btn" type="primary">
            下载
          </el-button>
        </download-file>
      </template>
    </template-import-dialog>
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle.vue'
import OnlineReviewWay from '@/components/online-review/project/OnlineReviewWay.vue'
import TemplateImportDialog from '@/components/common/TemplateImportDialog.vue'
import DownloadFile from '@/components/common/DownloadFile.vue'
import { cloneDeep, isEqual } from 'lodash'
import {
  onlineReviewMethodDict,
  inquiryReviewTypeDict,
  onlineReviewTypeDict,
  inquiryReviewScoringSchemeDict
} from '@/dictionary/project/online-review'
import { inquiryReviewModelDict } from '@/dictionary/project/inquiry'
import {
  exportPurchaseReviewListApi,
  importPurchaseReviewListApi
} from '@/api/procure/purchase-review'

function getReviewWay(wayType, reviewMethod, index) {
  return {
    // 名称
    title: inquiryReviewTypeDict.translate(wayType).label,
    // 序号
    orderNum: index,
    // 评审办法类型
    wayType: wayType,
    // 评审方式
    reviewMethod: reviewMethod,
    // 评审总分
    scoreSum: null,
    // 评审点列表
    itemInfoList: []
  }
}

/**
 * @description 询比在线评审列表
 */
export default {
  name: 'OnlineReviewWayList',

  components: {
    BaseSectionTitle,
    OnlineReviewWay,
    TemplateImportDialog,
    DownloadFile
  },

  model: {
    prop: 'reviewList',
    event: 'change'
  },

  props: {
    reviewId: {
      type: [String, Number],
      default: ''
    },

    reviewList: {
      type: Array,
      default: () => []
    },

    readOnly: {
      type: Boolean,
      default: false
    },

    showSectionTitle: {
      type: Boolean,
      default: true
    },

    // 是否在供应商端显示
    inSupplier: {
      type: Boolean,
      default: false
    },

    reviewModel: {
      type: [Number, String],
      default: inquiryReviewModelDict.SYNTHESIS.value
    }
  },

  data() {
    return {
      inquiryReviewTypeDict,
      inquiryReviewModelDict,

      form: {
        checkList: [
          inquiryReviewTypeDict.QUALIFICATION.value,
          inquiryReviewTypeDict.QUOTATION.value
        ]
      },
      reviewWayObj: {},
      list: [],
      activeIndex: 0,
      // reviewWayOption: [onlineReviewMethodDict.PASS],
      reviewWayOption: [],
      sortDialogVisible: false,

      uploadReviewFile: null,

      importVisible: false,

      importData: null
    }
  },

  watch: {
    reviewList: {
      handler(val) {
        if (val?.length) {
          this.list = cloneDeep(val).filter(item => item)
          this.list.forEach(item => {
            item.title = inquiryReviewTypeDict.translate(item.wayType).label
          })
          this.form.checkList = this.list.map(item => item.wayType)
        }
      },
      deep: true
    },

    list: {
      handler(val) {
        if (val?.length && !isEqual(val, this.reviewList)) {
          this.$emit('change', cloneDeep(val))
        }
      },
      deep: true
    }
  },

  async created() {
    if (!this.readOnly) {
      // 如果是综合评分法，默认全选
      if (this.reviewModel === inquiryReviewModelDict.SYNTHESIS.value) {
        this.form.checkList = [
          inquiryReviewTypeDict.QUALIFICATION.value,
          inquiryReviewTypeDict.BUSINESS.value,
          inquiryReviewTypeDict.QUOTATION.value
        ]
      }
      await this.initReviewObj()
      await this.changeReviewList()
    }
  },

  methods: {
    initReviewObj() {
      // 通过型评审
      const PASS = onlineReviewMethodDict.PASS.value
      // 打分型评审
      const SCORE = onlineReviewMethodDict.SCORE.value
      let list = []
      // 综合分评审
      if (Number(this.reviewModel) === inquiryReviewModelDict.SYNTHESIS.value) {
        // 初步评审
        const QUALIFICATION = getReviewWay(
          inquiryReviewTypeDict.QUALIFICATION.value,
          PASS,
          1
        )
        // 综合评审
        const BUSINESS = getReviewWay(
          inquiryReviewTypeDict.BUSINESS.value,
          SCORE,
          2
        )
        // 价格分评审
        const QUOTATION = getReviewWay(
          inquiryReviewTypeDict.QUOTATION.value,
          SCORE,
          3
        )
        list = [QUALIFICATION, BUSINESS, QUOTATION].filter(item => item)
        this.reviewWayOption = [
          inquiryReviewTypeDict.QUALIFICATION,
          inquiryReviewTypeDict.BUSINESS,
          inquiryReviewTypeDict.QUOTATION
        ]
      }
      // 最低分评审
      if (
        Number(this.reviewModel) === inquiryReviewModelDict.LOWEST_MARK.value
      ) {
        const QUALIFICATION = getReviewWay(
          inquiryReviewTypeDict.QUALIFICATION.value,
          PASS,
          1
        )
        const QUOTATION = getReviewWay(
          inquiryReviewTypeDict.QUOTATION.value,
          SCORE,
          2
        )
        list = [QUALIFICATION, QUOTATION].filter(item => item)
        this.reviewWayOption = [
          inquiryReviewTypeDict.QUALIFICATION,
          inquiryReviewTypeDict.QUOTATION
        ]
      }

      list.forEach(item => {
        this.reviewWayObj[item?.wayType] = item
      })
    },

    changeReviewList() {
      const tempList = cloneDeep(this.list)
      const resultList = []
      this.form.checkList.forEach(item => {
        const wayIndex = tempList.findIndex(way => way.wayType === item)

        if (wayIndex > -1) {
          resultList.push(tempList[wayIndex])
        } else {
          // 初步评审、价格分评审必选且不可取消
          resultList.unshift(this.reviewWayObj[item])
        }
      })
      resultList.sort((a, b) => a.orderNum - b.orderNum)
      this.list = resultList.filter(item => item)
      this.activeIndex = this.form.checkList.length
      this.$forceUpdate()
    },

    validateWayList() {
      return new Promise((resolve, reject) => {
        Promise.allSettled(
          this.form.checkList.map(item => {
            // 最低价法评审，不校验价格分
            if (
              this.reviewModel == inquiryReviewModelDict.LOWEST_MARK.value &&
              item == inquiryReviewTypeDict.QUOTATION.value
            ) {
              return true
            } else {
              const ref = this.$refs[`way${item}`][0]
              return ref.validateListForm()
            }
          })
        ).then(res => {
          if (res.some(item => item.status === 'rejected')) {
            reject()
          } else {
            resolve(true)
          }
        })
        // resolve(true)
      })
    },

    /**
     * 导出评审办法excel
     */
    exportExcel() {
      if (this.readOnly) {
        const params = {
          reviewId: this.reviewId
        }
        window.open(exportPurchaseReviewListApi(params), '_blank')
      } else {
        this.$emit('exportReview')
      }
    },

    /**
     * 上传评审办法模板文件
     */
    uploadTemplate(file) {
      importPurchaseReviewListApi({ file })
        .then(res => {
          // 判断导入数据是否符合综合评审的要求，即在综合评分法下，必须有价格分
          const quoteReviewIndex = (res.data || []).findIndex(
            item => item.wayType === inquiryReviewTypeDict.QUOTATION.value
          )
          let canImport = true
          if (this.reviewModel === inquiryReviewModelDict.SYNTHESIS.value) {
            canImport = quoteReviewIndex > -1
          }
          if (!canImport) {
            this.$message.error('请上传平台提供的评审办法导入模板')
            this.$refs.templateImportDialog.removeFile()
            return
          }
          this.importData = (res.data || [])
            .map(item => {
              item.itemInfoList = item.itemList.filter(item => {
                return !isNaN(Number(item.orderNum))
              })
              delete item.itemList
              const passWayList = [
                onlineReviewTypeDict.QUALIFICATION.value,
                onlineReviewTypeDict.COMPLIANCE.value
              ]
              if (passWayList.includes(item.wayType)) {
                item.reviewMethod = onlineReviewMethodDict.PASS.value
              } else {
                item.reviewMethod = onlineReviewMethodDict.SCORE.value
              }
              return item
            })
            .map((way, index) => {
              // 后端导入数据的排序可能从0开始，修正排序从1开始
              return Object.assign({}, way, { orderNum: index + 1 })
            })
          if (!this.importData?.length) {
            this.$message.warning('导入模板无数据，请重新上传')
          }
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 移除上传的模板
     */
    removeTemplate() {
      this.importData = null
    },

    confirmImport() {
      if (this.importData?.length > 0) {
        const isDefault =
          Number(this.reviewModel) === inquiryReviewModelDict.SYNTHESIS.value
        const isLowQuote =
          Number(this.reviewModel) === inquiryReviewModelDict.LOWEST_MARK.value
        if (isDefault) {
          // 综合分评审
          this.list = this.importData.filter(item => {
            // 价格分评审只有一项，若有多余则过滤掉，且价格分评审只选择平均分的评分方案
            if (item.wayType === inquiryReviewTypeDict.QUOTATION.value) {
              item.scoreMethod = inquiryReviewScoringSchemeDict.AVERAGE.value
              if (item?.itemInfoList && item?.itemInfoList.length > 1) {
                const itemInfoList = cloneDeep(item.itemInfoList[0])
                item.itemInfoList = [itemInfoList]
              }
            }
            return item
          })
        }
        if (isLowQuote) {
          // 最低价分评审
          this.list = this.importData
            .filter(item => {
              return item.wayType !== inquiryReviewTypeDict.BUSINESS.value
            })
            .map(item => {
              if (item.wayType === inquiryReviewTypeDict.QUOTATION.value) {
                item = getReviewWay(
                  inquiryReviewTypeDict.QUOTATION.value,
                  onlineReviewMethodDict.SCORE.value,
                  2
                )
              }
              return item
            })
          if (
            this.list.findIndex(
              item => item.wayType === inquiryReviewTypeDict.QUOTATION.value
            ) < 0
          ) {
            this.list.push(
              getReviewWay(
                inquiryReviewTypeDict.QUOTATION.value,
                onlineReviewMethodDict.SCORE.value,
                2
              )
            )
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.review-list {
  background: $white-color;
  border-radius: 4px;

  .review-way {
    &:not(:first-child) {
      margin-top: 32px;
    }
  }
}

.review-explain {
  padding-top: 20px;
  border-top: 1px dashed $info-third-color;

  .explain-title {
    margin-bottom: 8px;
  }

  ol {
    padding: 0 0 0 16px;
    line-height: 1.5;
  }
}

.tips {
  color: $info-color;
  margin-bottom: 0px !important;
}

.upload-btn {
  border: 1px solid $primary-color;
  color: $primary-color;
  border-radius: 5px;
  padding: 2px 8px;
  cursor: pointer;
  display: inline-block;
  span {
    font-size: 12px;
    color: $third-text-color;
  }
  &:hover {
    color: $white-color;
    background-color: $primary-color;
    span {
      color: $white-color;
    }
  }
}
</style>
